import React from "react";

export const InstructurDashboard = React.lazy(() =>
  import("./Dashboard/index")
);
export const InstructurSidebar = React.lazy(() => import("./Sidebar/index"));
export const CourseManager = React.lazy(() => import("./CourseManager/index"));
export const AddCourse = React.lazy(() => import("./AddCourse/index"));
export const SalesReport = React.lazy(() => import("./SalesReport/index"));
export const PayoutReport = React.lazy(() => import("./PayoutReport/index"));
export const PayoutSettings = React.lazy(() => import("./PayoutSetting/index"));
export const InstructorHome = React.lazy(() => import("./Home/index"));
export const ZoomLiveSetting = React.lazy(() =>
  import("./ZoomLiveSetting/index")
);
